<template>
    <div class="footBox">
        <div class="footTop spb">
            <div class="footItem">
                <div class="title">关于</div>
                <div class="footText" v-for="(item,index) in footData.guanyu" :key="index" @click="footTap(item.url)">{{ item.name }}</div>
            </div>
            <div class="footItem" style="flex: 1;">
                <div class="title">联系我们</div>
                <div class="footText" v-for="(item,index) in footData.lianxi" :key="index">{{ item.name }}: {{ item.url }}</div>
            </div>
            <div class="flex">
                <div class="footCodeBox column" v-for="(item,index) in footData.qrcode" :key="index">
                    <div class="codeTitle">{{ item.name }}</div>
                    <el-image :src="item.pic" fit="cover" class="footCode"></el-image>
                    <div class="codeTips">{{ item.url }}</div>
                </div>
            </div>
        </div>
        <div class="footLine"></div>
        <div class="footBottom flex">
            <div class="copyRight" v-for="(item,index) in footData.bottom" :key="index" @click="footTap(item.url)">{{ item.name }}&nbsp;</div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                footData: {},
            }
        },
        mounted(){
            this.getAppFoot()
        },
        methods: {
            // 网站尾数据
            getAppFoot(){
                this.request.get("index/index/bottom",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.footData = res.data
                })
            },
            // 跳转
            footTap(e){
                if(e != ''){
                    window.location.href = e
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .footBox{
        width: 100vw;
        background: #313342;
        .footTop{
            width: 1232px;
            height: 276px;
            padding-top: 95px;
            margin: 0 auto;
            .footItem{
                margin-right: 200px;
                &:first-child{
                    .footText{
                        cursor: pointer;
                    }
                }
                .title{
                    font: bold 24px/32px "Microsoft YaHei";
                    color: #fff;
                    padding-bottom: 12px;
                }
                .footText{
                    font: 14px/18px "Microsoft YaHei";
                    margin-top: 12px;
                    color: rgba(255,255,255,0.65);
                    &:hover{
                        color: #fff;
                    }
                }
            }
            .footCodeBox{
                margin-right: 62px;
                &:last-child{
                    margin: 0;
                }
                .codeTitle{
                    font: bold 18px/24px "Microsoft YaHei";
                    color: #fff;
                }
                .footCode{
                    width: 90px;
                    height: 90px;
                    border-radius: 8px;
                    margin-top: 16px;
                }
                .codeTips{
                    font: 14px/18px "Microsoft YaHei";
                    color: #fff;
                    margin-top: 16px;
                }
            }
        }
        .footLine{
            width: 100vw;
            height: 2px;
            background: rgba(255,255,255,0.08);
        }
        .footBottom{
            width: 1232px;
            padding: 38px 0;
            margin: 0 auto;
            .copyRight{
                font: 14px/18px "Microsoft YaHei";
                color: rgba(255,255,255,0.65);
                text-align: center;
                margin-top: 20px;
                cursor: pointer;
                &:hover{
                    color: #fff;
                }
            }
        }
    }
</style>